<template>
  <RichTextView :value="value" :truncate="truncate" :headings="false" :compact="true"/>
</template>

<script>
import RichTextView from '@/components/richText/RichTextView.vue';

// Shows a task text field with its bold, italic, underline (US 9390) and lists (US 9394).
// With truncate, a long text is shortened as plain text.
export default {
  name: 'FormattedNoteText',
  components: {
    RichTextView
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    truncate: {
      type: Number,
      default: 0
    }
  }
};
</script>
